// eslint-disable-next-line no-unused-vars
import BiodataRepository from '../../../domain/repositories/BiodataRepository';

class DeleteBiodataUseCase {
    /**
     * @param {BiodataRepository} biodataRepository
     */
    constructor(biodataRepository) {
        this.biodataRepository = biodataRepository;
    }

    /**
     * @param {string} biodataId
     * @returns {Promise<void>}
     */
    async execute(biodataId) {
        return this.biodataRepository.deleteBiodata(biodataId);
    }
}

export default DeleteBiodataUseCase;
